module.exports = __webpack_public_path__ + "static/media/TG.42ed87fa.png";